import { GET_APP_CONFIGS, GET_APP_CONFIGS_SUCCESS, GET_APP_CONFIGS_ERROR, GET_APP_CONFIGS_SUCCESS_NO_UPDATE, GET_SITEMAP_DATA, GET_SITEMAP_DATA_SUCCESS, GET_SITEMAP_DATA_ERROR, } from '../../constants';
export const getAppConfigs = (payload) => {
    return {
        type: GET_APP_CONFIGS,
        payload,
    };
};
export const getAppConfigsSuccess = (result) => {
    return {
        type: GET_APP_CONFIGS_SUCCESS,
        result,
    };
};
export const getAppConfigsSuccessNoUpdate = () => {
    return {
        type: GET_APP_CONFIGS_SUCCESS_NO_UPDATE,
    };
};
export const getAppConfigsError = () => {
    return {
        type: GET_APP_CONFIGS_ERROR,
    };
};
export const getSitemapData = () => {
    return {
        type: GET_SITEMAP_DATA,
    };
};
export const getSitemapDataSuccess = (result) => {
    return {
        type: GET_SITEMAP_DATA_SUCCESS,
        result,
    };
};
export const getSitemapDataError = () => {
    return {
        type: GET_SITEMAP_DATA_ERROR,
    };
};
